
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiTipiOperazioniDialog extends Serenity.EntityDialog<ApiTipiOperazioniRow, any> {
        protected getFormKey() { return ApiTipiOperazioniForm.formKey; }
        protected getIdProperty() { return ApiTipiOperazioniRow.idProperty; }
        protected getLocalTextPrefix() { return ApiTipiOperazioniRow.localTextPrefix; }
        protected getNameProperty() { return ApiTipiOperazioniRow.nameProperty; }
        protected getService() { return ApiTipiOperazioniService.baseUrl; }
        protected getDeletePermission() { return ApiTipiOperazioniRow.deletePermission; }
        protected getInsertPermission() { return ApiTipiOperazioniRow.insertPermission; }
        protected getUpdatePermission() { return ApiTipiOperazioniRow.updatePermission; }

        protected form = new ApiTipiOperazioniForm(this.idPrefix);

    }
}